import { render } from "./detailinfo.vue?vue&type=template&id=632a7fae&scoped=true&ts=true"
import script from "./detailinfo.vue?vue&type=script&lang=ts"
export * from "./detailinfo.vue?vue&type=script&lang=ts"

import "./detailinfo.vue?vue&type=style&index=0&id=632a7fae&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632a7fae"]])

export default __exports__